import apiClient from '../api-client';
import type { SpecialDateOperatingHours } from '@geely/shared';

export interface SpecialDateHoursQueryParams {
  storeId: string;
}

export const specialDateHoursApi = {
  list: (params: SpecialDateHoursQueryParams) =>
    apiClient.get<SpecialDateOperatingHours[]>('/special-date-operating-hours', { params }),
};
